var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.676,
    height: 38.322,
    viewBox: "0 0 32.676 38.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18578",
    "data-name": "Group 18578",
    transform: "translate(24013.5 14634.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46480",
    "data-name": "Path 46480",
    d: "M33.907,9.415,26.186,1.693a.6.6,0,0,0-.45-.193H5.984C4.615,1.507,4.507,2.615,4.5,3.984V16.3a.643.643,0,1,0,1.287,0V3.984c0-.661-.118-1.177.543-1.177l18.762-.02V9.865a.643.643,0,0,0,.643.643h7.078v25.83c0,.661.17,1.185-.491,1.185L6.3,37.614c-.661,0-.516-.615-.516-1.276V33.031a.643.643,0,0,0-1.287,0v3.308c.007,1.369.115,2.477,1.484,2.484H32.617c1.369-.007,1.477-1.115,1.484-2.484V9.865A.6.6,0,0,0,33.907,9.415ZM26.379,3.7,31.9,9.222H26.379Z",
    transform: "translate(-24015.426 -14635.5)",
    fill: "#0055af",
    stroke: "#0055af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46481",
    "data-name": "Path 46481",
    d: "M29.527,25.285v-8.7A2.072,2.072,0,0,0,27.442,14.5H4.585A2.072,2.072,0,0,0,2.5,16.585v8.7A2.072,2.072,0,0,0,4.585,27.37H27.442a2.072,2.072,0,0,0,2.085-2.085ZM8.291,22.621a2.214,2.214,0,0,0,1.622.682,2.432,2.432,0,0,0,.952-.193,3.423,3.423,0,0,0,.875-.631l.734.746A3.359,3.359,0,0,1,9.9,24.41a3.449,3.449,0,0,1-2.574-.978A3.49,3.49,0,0,1,9.9,17.46a3.346,3.346,0,0,1,2.574,1.158l-.721.785a2.883,2.883,0,0,0-.9-.643,2.39,2.39,0,0,0-2.561.476A2.188,2.188,0,0,0,7.6,20.909,2.317,2.317,0,0,0,8.291,22.621Zm9.562,1.287a2.651,2.651,0,0,1-1.737.541,4.093,4.093,0,0,1-2.793-1.081l.708-.862a3.2,3.2,0,0,0,2.111.888,1.467,1.467,0,0,0,.875-.232.734.734,0,0,0,.322-.631.7.7,0,0,0-.309-.6,3.05,3.05,0,0,0-1.042-.386,10.7,10.7,0,0,1-1.12-.335,2.226,2.226,0,0,1-.682-.386,1.609,1.609,0,0,1-.592-1.377A1.66,1.66,0,0,1,14.276,18a2.716,2.716,0,0,1,1.673-.5,4,4,0,0,1,1.287.206,3.333,3.333,0,0,1,1.094.6l-.6.849a2.188,2.188,0,0,0-.811-.438,3.063,3.063,0,0,0-1-.18,1.583,1.583,0,0,0-.811.206.669.669,0,0,0-.309.6.721.721,0,0,0,.309.631,5.148,5.148,0,0,0,1.351.463,3.745,3.745,0,0,1,1.557.695,1.686,1.686,0,0,1,.528,1.287,1.8,1.8,0,0,1-.695,1.441ZM23,24.371H21.715l-2.69-6.705h1.287l2.072,5.006,2.059-5.006H25.73Z",
    transform: "translate(-24016 -14631.77)",
    fill: "#0055af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.f1263bf8d459bd7f5f93499d7f64c33f.svg";
export { ForwardRef as ReactComponent };